import { fromJS } from 'immutable';
import * as constants from '../messaging-constants';
import R from 'ramda';

const initialConvListState = fromJS({
  convList: [],
  selectedConv: {},
  hoveredConv: {},
  loadingConvList: false,
});

export default (state = initialConvListState, { type, payload }) => {
  switch (type) {
    case 'UPDATE_PROPS_IN_MESSAGING_CONVS':
      return state.merge(fromJS(payload));
    case constants.LOADING_LIST:
      return state.set('loadingConvList', !state.get('loadingConvList'));
    case constants.LIST_LOADED:
      return state.merge(fromJS({
        loadingConvList: false,
        convList: payload,
      }));
    case constants.MSGS_LOADED_INITIALLY:
      return state.set('selectedConv', fromJS(payload.conv[0]))
      .update('convList', convList => convList.map(conv => {
        if (conv.get('messageId') === payload.conv.messageId) return conv.set('hasSeen', true);
        return conv;
      }));
    case 'GET_HISTORY_FEEDS':
      const convList = state.get('convList').toJS();
      if (convList && convList.length) {
        const selectedConv = R.find(R.eqProps('contractId', payload), convList);
        if (selectedConv) {
          return state.set('selectedConv', fromJS(selectedConv))
            .update('convList', list => list.map(conv => {
              if (conv.get('contractId') === payload.contractId) return conv.set('hasSeen', true);
              return conv;
            }));
        }
      }
      return state;
    case constants.TOGGLE_CONV_DONESS:
      return state.update('convList', list => list.filter(conv => {
        return conv.get('messageId') !== payload.messageId;
      }));
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/components/messaging/messagingStore/reducers/convs-reducer.js